import { createContext, use } from 'react';

export interface ClusterConfig {
  apiBaseUrl: string;
  apiKey: string;
}

export const ClusterContext = createContext<ClusterConfig | undefined>(undefined);

export const useCluster = () => {
  const context = use(ClusterContext);

  if (context === undefined) {
    throw new Error('useCluster must be used within ClusterProvider');
  }

  return context;
};
